import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'

type EngagementMetrics = {
  qualityMetrics: {
    totals: {
      accuracy: number
      f1Score: number
      falseNegativeCount: number
      falsePositiveCount: number
      iou: number
      precision: number
      recall: number
      trueNegativeCount: number
      truePositiveCount: number
    }
  }
  auditScoreAccuracy: {
    audit_score_id: string
    accuracy: number
  }
}

export function useGetByID(id?: string, enabled?: boolean) {
  return useQuery({
    queryKey: ['qualityMetricsByEngagement', id],
    queryFn: async () => {
      const { data } = await apiClient.get<EngagementMetrics>(`/int/metrics/quality/engagements/${id}`)
      return data
    },
    enabled: Boolean(id) && Boolean(enabled),
    retry: false,
  })
}
